const seedrandom = require('seedrandom');

const init = (seed) => {
    seedrandom(seed, {global: true});
};
const random = (min, max) => { // min and max included 
    return Math.floor(Math.random() * (max - min + 1) + min)
};

module.exports = {init, random};